import React, { useContext, useEffect } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { EditPatient } from '../Patient/EditPatient';
import { MedicalProfessional } from './MedicalProfessional';
import { Insurance } from './Insurance';
import { FinancialInformation } from './FinancialInformation';
import { TermsOfService } from './TermsOfService';
import { Agreements } from './Agreements';

export const PatientIndex = () => {
  return (
    <Switch>
      <Route
        path='/patient/medical-professional'
        component={MedicalProfessional}
      />
      <Route path='/patient/insurance' component={Insurance} />
      <Route path='/patient/finances' component={FinancialInformation} />
      <Route path='/patient/terms-of-service' component={TermsOfService} />
      <Route path='/patient/agreements' component={Agreements} />
      <Route path='/' component={EditPatient} />
    </Switch>
  );
};
